// extracted by mini-css-extract-plugin
export var bio = "bio-module--bio--7c31e";
export var expandableContent = "bio-module--expandableContent--e2642";
export var expanded = "bio-module--expanded--abfef";
export var readMoreToggle = "bio-module--readMoreToggle--a7cce";
export var wrapper = "bio-module--wrapper--bbf95";